import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.c5h().m5j(), $completion));
  return SavedHttpCall().v5k(_this__u8e3s4.x5g_1, _this__u8e3s4.x5i(), _this__u8e3s4.c5h(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static v5k(client, request, response, responseBody) {
        var $this = this.w5i(client);
        $this.t5k_1 = responseBody;
        $this.z5g_1 = new (SavedHttpRequest())($this, request);
        $this.a5h_1 = new (SavedHttpResponse())($this, $this.t5k_1, response);
        checkContentLength(contentLength(response), fromInt($this.t5k_1.length), request.f5j());
        $this.u5k_1 = true;
        return $this;
      }
      z5i() {
        return this.u5k_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.w5k_1 = origin;
        this.x5k_1 = call;
      }
      e5j() {
        return this.x5k_1;
      }
      sv() {
        return this.w5k_1.sv();
      }
      f5j() {
        return this.w5k_1.f5j();
      }
      g5j() {
        return this.w5k_1.g5j();
      }
      y5i() {
        return this.w5k_1.y5i();
      }
      e2o() {
        return this.w5k_1.e2o();
      }
      w50() {
        return this.w5k_1.w50();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.y5k_1 = call;
        this.z5k_1 = body;
        this.a5l_1 = origin.n5j();
        this.b5l_1 = origin.o5j();
        this.c5l_1 = origin.p5j();
        this.d5l_1 = origin.q5j();
        this.e5l_1 = origin.w50();
        this.f5l_1 = origin.sv();
      }
      e5j() {
        return this.y5k_1;
      }
      n5j() {
        return this.a5l_1;
      }
      o5j() {
        return this.b5l_1;
      }
      p5j() {
        return this.c5l_1;
      }
      q5j() {
        return this.d5l_1;
      }
      w50() {
        return this.e5l_1;
      }
      sv() {
        return this.f5l_1;
      }
      m5j() {
        return ByteReadChannel(this.z5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1y71vsgu0wj47,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
